// extracted by mini-css-extract-plugin
module.exports =  {"banner":"a10a3f92e9--banner--qSkej","logo":"a10a3f92e9--logo--xLPdI","paragraph":"a10a3f92e9--paragraph--UEb5G","rate":"a10a3f92e9--rate--tGCzV"};